export {
  getKiosks, createKiosks, unregisterKiosk, updateKiosk,
} from './dispatchers';
